import useGlobalEvents from "../../hooks/useGlobalEvents";

const GlobalEvents = () => {
    useGlobalEvents();

    return null;
}

export default GlobalEvents;